// extracted by mini-css-extract-plugin
export default {"wrap":"BaseModal-module__wrap--CSlRl","modal":"BaseModal-module__modal--jeeji"};